@if (state().status === 'error') {
<p class="dashboard-kpi__message">{{ 'Dashboard.KpiLoadFailed' | translate }}</p>
} @else if (unconfigured()) {
<p class="dashboard-kpi__message">{{ 'Dashboard.KpiUnconfigured' | translate }}</p>
} @else {
<pulse-kpi-card-grid [direction]="direction()" [minCardWidth]="200">
    @for (card of cards(); track card.id) {
    <pulse-kpi-card
        [label]="card.label"
        [hint]="card.hint"
        [value]="card.value"
        [valueSuffix]="card.valueSuffix"
        [caption]="card.caption"
        [icon]="card.icon"
        [status]="card.iconColor"
        [valueEmphasis]="presentation().valueEmphasis"
        [alignment]="presentation().alignment"
        [labelEmphasis]="presentation().labelEmphasis"
        [loading]="state().status === 'loading'"
        [link]="card.link"
        [interactive]="card.interactive"
        (activate)="navigate(card)"
    />
    }
</pulse-kpi-card-grid>
}
